import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleExchange } = useAuthStore();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    googleExchange(sessionId)
      .then((user) => {
        // clear hash
        window.history.replaceState({}, document.title, window.location.pathname);
        if (!user?.onboarding_complete) {
          navigate("/onboarding", { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      })
      .catch(() => {
        setError("We couldn't sign you in. Please try again.");
      });
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-canvas" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-display text-[24px]">Signing you in</div>
        <p className="text-sm text-ink-muted mt-1">Just a second…</p>
        {error && (
          <button
            onClick={() => navigate("/login")}
            className="mt-4 text-[14px] underline"
          >
            Back to login
          </button>
        )}
      </div>
    </div>
  );
}
